import React from 'react'
import { FormDataConsumer } from 'react-admin'
import { LocationPricingRuleSet } from 'services/api/entities/catalog/location/types/internal/location-models'
import { locationPricingNameChoices } from 'services/cfg/form'
import { FormDataConsumerProps } from 'types/common'
import PricingByRulesInput from './PricingByRulesInput'
import PricingRulesArrayInput from './PricingRulesArrayInput'

const LocationByRulePricingInput: React.FC = () => (
  <PricingByRulesInput>
    <FormDataConsumer>
      {({
        scopedFormData: pricingRuleSet,
        getSource,
      }: FormDataConsumerProps<Location, LocationPricingRuleSet>) => (
        <PricingRulesArrayInput
          nameChoices={locationPricingNameChoices}
          ruleSet={pricingRuleSet}
          source={getSource!('pricingRules')}
        />
      )}
    </FormDataConsumer>
  </PricingByRulesInput>
)

export default LocationByRulePricingInput
